import i18n from '@/lang';
/* unplugin-vue-components disabled */
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "order-item",
    class: {
      card: _vm.isCard
    },
    style: {
      height: _vm.miniStyle.height,
      padding: _vm.miniStyle.padding
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "font-size-h3-large smy__text-overflow-one-line title"
  }, [_vm.hasTempIcon ? _c('div', {
    staticClass: "temp-icon"
  }, [_vm._t("temp-icon")], 2) : _vm._e(), _c('div', {
    staticClass: "content smy__text-overflow-one-line"
  }, [_vm._t("title")], 2), _vm.priority && _vm.priority != 1 ? _c('div', {
    staticClass: "priority font-size-h4-normal",
    class: {
      'priority-2': _vm.priority === 2,
      'priority-3': _vm.priority === 3
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(" " + _vm._s(_vm.priorityMapping[_vm.priority]) + " ")])]) : _vm._e()]), _vm.ding && [2, 3, 7].indexOf(_vm.ding) !== -1 || _vm.inside === 1 || _vm.moreOperation.length > 0 ? _c('div', {
    staticClass: "source"
  }, [_vm.ding && [2, 3, 7].indexOf(_vm.ding) !== -1 ? _c('div', {
    staticClass: "source-icon"
  }, [_c('img', {
    attrs: {
      "src": "/spa_static_mobile/icon/" + _vm.sourceIcon[_vm.ding] + ".png",
      "width": "100%",
      "height": "100%"
    }
  })]) : _vm._e(), _vm.inside === 1 ? _c('div', {
    staticClass: "source-icon"
  }, [_c('img', {
    attrs: {
      "src": "/spa_static_mobile/icon/icon_inside32_32@3x.png",
      "width": "100%",
      "height": "100%"
    }
  })]) : _vm._e()]) : _vm._e()]), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "right-tip"
  }, [_vm._t("status", function () {
    return [_c('div', {
      staticClass: "status font-size-h3-normal",
      style: {
        color: _vm.statusColorMapping[_vm.status]
      }
    }, [_vm._v(" " + _vm._s(_vm.refuse ? i18n.tc("10") : _vm.orderStatusMapping.get(_vm.status + "_" + _vm.evaluate)) + " ")])];
  }), _c('div', {
    staticClass: "timeout font-size-h4-normal"
  })], 2), _vm.hasNo ? _c('div', {
    staticClass: "font-size-h4-large no"
  }, [_vm._t("no")], 2) : _vm._e(), _vm.hasTime ? _c('div', {
    staticClass: "font-size-h4-large time"
  }, [_vm._t("time"), _vm.time && [0, 1, 2, 3].indexOf(_vm.status) !== -1 ? _c('div', {
    staticClass: "appointment-time"
  }, [_vm._v(" " + _vm._s(_vm.formatNowTime) + " ")]) : _vm._e()], 2) : _vm._e(), _vm.hasCustomer ? _c('div', {
    staticClass: "font-size-h4-large customer"
  }, [_vm._t("customer")], 2) : _vm._e(), _vm.hasAddress ? _c('div', {
    staticClass: "font-size-h4-large address smy__text-overflow-one-line"
  }, [_vm._t("address")], 2) : _vm._e()]), _vm.abnormal === 1 ? _c('div', {
    staticClass: "abnormal"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icon/abnormal.png"),
      "width": "100%",
      "height": "100%"
    }
  })]) : _vm._e(), _vm.examine === 1 ? _c('div', {
    staticClass: "under-icon"
  }, [_c('img', {
    attrs: {
      "src": "/spa_static_mobile/icon/under_approval237_195@3x.png",
      "width": "100%",
      "height": "100%"
    }
  })]) : _vm._e(), _vm._t("default")], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };